import { Box } from '@chakra-ui/react';
import { BaseTable } from '@cks-internal/react-base';
import { useWexCardTransactionQuery } from './api/useWexCardTransactionQuery';
import { useWexCardTransactionColumns } from './hooks/useWexCardTransactionColumns';
import { WexCardTransactionType } from './types';
import { useMemo } from 'react';

type Props = {
  cardId: string;
  activityId: number;
  transactionTypeFilter?: WexCardTransactionType;
  tableHeight?: number;
};

export const VirtualCardTransactionDisplay = ({ cardId, activityId, transactionTypeFilter, tableHeight }: Props) => {
  const { data, isLoading, isError } = useWexCardTransactionQuery(activityId, cardId);
  const columns = useWexCardTransactionColumns();

  const filteredTransactions = useMemo(() => {
    if (!transactionTypeFilter || !data) return data;

    return data.filter((transaction) => transaction.Type === transactionTypeFilter);
  }, [transactionTypeFilter, data]);

  if (isError || isLoading) {
    return null;
  }

  if (data?.length === 0) {
    return <Box>No transactions found for this card.</Box>;
  }

  return (
    <Box>
      <BaseTable
        disableGlobalFilter={true}
        stickyHeaders={tableHeight ? { tableHeight: [`${tableHeight}px`] } : undefined}
        data={filteredTransactions}
        columns={columns}
        isLoading={isLoading}
      />
    </Box>
  );
};
